import React from 'react';
import PropTypes from 'prop-types';

import { Layout } from 'antd';

import EditableSection from '../../../components/EditableSection';
import ResetSettings from '../../../components/ResetSettings';
import PDFExport from '../../../components/PDFExport';
import DimensionsEditor from '../../../containers/DimensionsEditor';
import GatesEditor from '../../../containers/GatesEditor';
import ConstructionExtras from '../../../containers/ConstructionExtras';
import PressingEditor from '../../../containers/PressingEditor';
import AnchoringEditor from '../../../containers/AnchoringEditor';
import ClosingEditor from '../../../containers/ClosingEditor';
import BoltEditor from '../../../containers/BoltEditor';
import InsideEditor from '../../../containers/InsideEditor';
import MoistureEditor from '../../../containers/MoistureEditor';
import PadlockEditor from '../../../containers/PadlockEditor';
import ColorEditor from '../../../containers/ColorEditor';
import CustomizedGarage from '../../../components/CustomisedGarage';

import { sider } from '../../../utils/variables.styles';

import {
  SiderContainer
} from './Sider.styles';
import StructureEditor from '../../../containers/StructureEditor';
import ToolingEditor from '../../../containers/ToolingEditor';
import AdditionalClosingEditor from '../../../containers/AdditionalClosingEditor';
import GatesPressingEditor from '../../../containers/GatesPressingEditor';
import Lattice from '../../../containers/Lattice';
import {useTranslation} from "../../../contexts/TranslationContext";
import {BgColorsOutlined, ReconciliationOutlined, TableOutlined} from "@ant-design/icons";
import EditableSubSection from "../../../components/EditableSubSection/EditableSubSection";

const SiderComponent = ({
  collapsed,
  resetSettings,
  translationsData = useTranslation(),
}) => {

  return (
    <Layout.Sider
      width={sider.width}
      style={{
        maxWidth: '100vw'
      }}
      collapsedWidth={sider.collapsedWidth}
      trigger={null}
      collapsible
      collapsed={collapsed}
    >
      <SiderContainer collapsed={collapsed}>
        <DimensionsEditor collapsed={collapsed} />
        <EditableSection
          collapsed={collapsed}
          icon={<BgColorsOutlined />}
          title={translationsData.garage_colors || 'garage_colors'}
        >
          <ColorEditor collapsed={collapsed} translationsData={translationsData}/>
        </EditableSection>
        <GatesEditor collapsed={collapsed} />
        <ConstructionExtras collapsed={collapsed} />
        <EditableSection
          collapsed={collapsed}
          icon={<TableOutlined />}
          title={translationsData.type_of_metal_embossing || 'type_of_metal_embossing'}
        >
          <PressingEditor collapsed={collapsed} />
          <EditableSubSection  title="GATES_EMBOSSING"
                              collapsed={collapsed}
            >
            <GatesPressingEditor collapse={collapsed} />
          </EditableSubSection>
          <ToolingEditor translationsData={translationsData} />
        </EditableSection>
        <EditableSection
          collapsed={collapsed}
          icon={<ReconciliationOutlined />}
          title={translationsData.additional_information || 'additional_information'}
        >
          <AnchoringEditor collapsed={collapsed} />
          <ClosingEditor collapsed={collapsed} />
          <AdditionalClosingEditor collapsed={collapsed} />
          <InsideEditor collapsed={collapsed} />
          <StructureEditor collapsed={collapsed} />
          <MoistureEditor collapsed={collapsed} />
          <BoltEditor collapsed={collapsed} />
          <PadlockEditor collapsed={collapsed} />
          <Lattice collapsed={collapsed} />
        </EditableSection>
      </SiderContainer>
      <ResetSettings
        translationsData={translationsData}
        resetConstruction={resetSettings}
        collapsed={collapsed}
      />
      <PDFExport collapsed={collapsed} translationsData={translationsData} />
      <CustomizedGarage collapsed={collapsed} translationsData={translationsData} />
    </Layout.Sider>
  );
};

SiderComponent.propTypes = {
  collapsed: PropTypes.bool.isRequired,
  resetSettings: PropTypes.func.isRequired
};

export default SiderComponent;
